(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-panel-hvs/assets/javascripts/draw-panel-hvs.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-panel-hvs/assets/javascripts/draw-panel-hvs.js');
"use strict";

const {
  Choose,
  When
} = svs.components.lbUtils.reactConditionals;
const {
  Currency: currency
} = svs.utils.format;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const {
  DrawPanel
} = svs.components.tipsen.drawSelectorComponents;
const {
  CurrencyCounter
} = svs.components.tipsen.currencyCounter;
const {
  useSelector
} = ReactRedux;
const {
  selectJackpotById,
  selectGuaranteedJackpotById,
  selectRolloverInById
} = svs.components.sport.drawsRedux.selectors;
const specialCurrency = curr => {
  const fractionChar = ',';
  const million = 1000000;
  const currInt = curr ? parseInt(curr.replace(/\s/, ''), 10) : 0;
  if (currInt === million) {
    return '1 miljon';
  } else if (currInt > million) {
    let millonFraction = (currInt / million).toString();
    millonFraction = millonFraction.replace('.', fractionChar);
    const commaPos = millonFraction.indexOf(fractionChar);
    if (commaPos !== -1) {
      const millionPart = millonFraction.substring(0, commaPos);
      const firstFraction = millonFraction[commaPos + 1];
      if (firstFraction === '0') {
        millonFraction = millionPart;
      } else {
        millonFraction = "".concat(millionPart).concat(fractionChar).concat(firstFraction);
      }
    }
    return "".concat(millonFraction, " miljoner");
  }
  return currency(curr);
};
const DrawPanelHvs = _ref => {
  var _ref2, _jackpot$jackpotAmoun;
  let {
    draw,
    isOpened,
    isLargeDevice,
    isExpanded,
    isSelected
  } = _ref;
  const {
    currentNetSale,
    regCloseTime,
    drawComment
  } = draw;
  const jackpot = useSelector(state => selectJackpotById(state, draw.productId, draw.drawNumber));
  const guaranteedJackpot = useSelector(state => selectGuaranteedJackpotById(state, draw.productId, draw.drawNumber));
  const rullpottJackpotAmount = useSelector(state => selectRolloverInById(state, draw.productId, draw.drawNumber));
  const jackpotAmount = (_ref2 = (_jackpot$jackpotAmoun = jackpot === null || jackpot === void 0 ? void 0 : jackpot.jackpotAmount) !== null && _jackpot$jackpotAmoun !== void 0 ? _jackpot$jackpotAmoun : guaranteedJackpot === null || guaranteedJackpot === void 0 ? void 0 : guaranteedJackpot.jackpotAmount) !== null && _ref2 !== void 0 ? _ref2 : 0;
  const classNames = ['pg_draw_panel_hvs'];
  if (isSelected) {
    classNames.push('pg_draw_panel_hvs--focused');
  }
  if (isExpanded) {
    classNames.push('pg_draw_panel_hvs--expanded');
  }
  if (isOpened) {
    classNames.push('pg_draw_panel_hvs--opened');
  }
  if (isLargeDevice) {
    classNames.push('pg_draw_panel_hvs--largedevice');
  }
  if (isLargeDevice && !isExpanded) {
    classNames.push('pg_draw_panel_hvs--tiny');
  }
  return React.createElement(DrawPanel, {
    className: classNames.join(' ')
  }, React.createElement("div", {
    className: "pg_draw_panel_hvs__details"
  }, React.createElement("div", {
    className: "pg_draw_panel_hvs__details__splash"
  }), React.createElement("p", {
    className: "pg_draw_panel_hvs__details__jackpotstatement"
  }, "I vinstpotten vid 13 r\xE4tt"), React.createElement("h3", {
    className: "pg_draw_panel_hvs__details__jackpotamount",
    translate: "no"
  }, "".concat(specialCurrency(jackpotAmount), " kr")), React.createElement(Choose, null, React.createElement(When, {
    condition: !isOpened
  }, React.createElement("h5", {
    className: "pg_draw_panel_hvs__details__drawdetail pg_draw_panel_hvs__details__drawdetail--not-started"
  }, "Spelomg\xE5ng ej startad")), React.createElement(When, {
    condition: Boolean(isOpened && rullpottJackpotAmount)
  }, React.createElement("h5", {
    className: "pg_draw_panel_hvs__details__drawdetail pg_draw_panel_hvs__details__drawdetail--jackpot"
  }, React.createElement("span", {
    translate: "no"
  }, "".concat(specialCurrency(rullpottJackpotAmount), " kr")), ' extra i 2:a vinstgruppen')), React.createElement(When, {
    condition: isOpened
  }, React.createElement("p", {
    className: "pg_draw_panel_hvs__details__drawdetail pg_draw_panel_hvs__details__drawdetail--comment"
  }, drawComment)))), React.createElement("div", {
    className: "summary pg_draw_panel_hvs__summary"
  }, React.createElement("div", {
    className: "pg_draw_panel_hvs__summary__item"
  }, React.createElement("p", {
    className: "pg_draw_panel_hvs__summary__item__title"
  }, "Oms\xE4ttning"), React.createElement("h4", {
    className: "pg_draw_panel_hvs__summary__item__value",
    translate: "no"
  }, React.createElement(CurrencyCounter, {
    amount: currentNetSale
  }), ' kr')), React.createElement("div", {
    className: "pg_draw_panel_hvs__summary__item"
  }, React.createElement("p", {
    className: "pg_draw_panel_hvs__summary__item__title"
  }, "Spelstopp"), React.createElement("h4", {
    className: "pg_draw_panel_hvs__summary__item__value"
  }, "".concat(formatDate(regCloseTime, true, true, false))))));
};
setGlobal('svs.components.tipsen.drawPanelHvs.DrawPanelHvs', DrawPanelHvs);

 })(window);